<div class="">
  <!-- Header -->
  <div class="modal-header">
    <div class="header-left">
      <div class="header-icon">
        <!-- <i class="bi bi-calendar2-event-fill"></i> -->
        <img src="assets/images/starcal.svg" style="width: 25px;"/>
      </div>
      <h2 class="cevent" *ngIf="!viewMode && !editMode">Create {{selectedTab}}</h2>
      <h2 class="cevent" *ngIf="viewMode && !editMode">View {{selectedTab}}</h2>
      <h2 class="cevent" *ngIf="editMode">Edit {{selectedTab}}</h2>
    </div>

    <div style="margin-left:  auto;" *ngIf="data">
    <i class="bi bi-pencil-square editEvent" *ngIf="data.event.owner" (click)="toggleEditMode()"></i>
    <i class="bi bi-trash delEvent" *ngIf="data.event.owner && viewMode" (click)="deleteDocument()"></i>
    </div>

    <img class="close-button" (click)="onCancel()" src="assets/images/close-circle.svg" alt="Close" />
  </div>

  <!-- Tabs -->
  <div class="tabs">
    <!-- <button class="tab" (click)="selectedTab = 'Event'; switchTab('Event')" style="font-size: 18px;" [class.active]="selectedTab === 'Event'">Event</button>
    <button class="tab" (click)="selectedTab = 'Reminder'; switchTab('Reminder')" style="font-size: 18px;" [class.active]="selectedTab === 'Reminder'">Reminder</button> -->
    
      <!-- Event tab -->
      <button class="tab" *ngIf="data?.event?.event_type !== 'reminder'" (click)="switchTab('Event')"
        [class.active]="selectedTab === 'Event'">
        Event
      </button>
    
      <!-- Reminder tab -->
      <button class="tab" *ngIf="(data?.event?.event_type === 'reminder' || data===null)" (click)="switchTab('Reminder')"
        [class.active]="selectedTab === 'Reminder'">
        Reminder
      </button>


    <!-- RSVP -->
    <div class="row atten" *ngIf="data?.event?.owner === false">
        <div class="attnd col-3">Attending</div>
        <div class="col-9 sflex">
        <div class="float-left" >
            <a href="javascript:void(0);" class="optionone compone" [class.active]="selectedValue === 'Yes'"
                (click)="onClickAttending('Yes')">Yes</a>
            <a href="javascript:void(0);" class="optiontwo comptwo" [class.active]="selectedValue === 'No'"
                (click)="onClickAttending('No')">No</a>
            <a href="javascript:void(0);" class="optiontwo comptwo compthree" [class.active]="selectedValue === 'Maybe'"
                (click)="onClickAttending('Maybe')">Maybe</a>
        </div>
        </div>
    </div>
    <!-- RSVP -->

  </div>

  <!-- Event Tab Content -->
   <div class="event-tab" *ngIf="selectedTab === 'Event'">
      <form [formGroup]="eventForm" class="modal-form" [ngClass]="{'scrollTab': viewMode || editMode}" aria-label="Create Event Form">
        <!-- Left side -->
        <div class="form-left">
          <input class="input-title" [class.disabled]="viewMode" maxlength="255" (input)="stripLeadingSpecialChars('title')" type="text" formControlName="title" placeholder="Add Event Title" aria-label="Add Event Title" />
          <div class="error-message" *ngIf="hasError('title')">
            Event title is required
          </div>

          <!-- Date and Time -->
            
          <!-- Date -->
          <div class="datetime-group">
              <div class="date-block">
                <div class="date-picker-wrapper">
                    <label class="field-label">Date</label>
                    <input matInput [class.disabled]="viewMode" style="cursor: pointer;" (click)="openStartPicker()" [matDatepicker]="startPicker" formControlName="startDate" readonly />
                    <!-- <mat-datepicker-toggle *ngIf="!viewMode" matSuffix [for]="startPicker"></mat-datepicker-toggle> -->
                     <img *ngIf="!viewMode" src="assets/datepicko.svg" alt="Pick date" style="width: 25px; cursor: pointer; margin-left: 8px;" (click)="startPicker.open()" />
                    <mat-datepicker *ngIf="!viewMode" #startPicker></mat-datepicker>
                </div>
                </div> 
          </div>

          <!-- Time -->
          <div class="datetime-group" *ngIf="!isAllDay">
            <div class="time-block">
              <div class="time-picker-wrapper">
                <!-- <label class="field-label">Time<span class="required">*</span></label> -->
                <img src="assets/addclock.svg" class="clkme"/>

                <!-- View Mode -->
                <ng-container *ngIf="viewMode; else editMode">
                  <span class="fromtoRep">{{ formatTime24to12(eventForm.get('fromTime')?.value) }}</span>
                  <span class="to-text">To</span>
                  <span class="fromtoRep">{{ formatTime24to12(eventForm.get('toTime')?.value) }}</span>
                </ng-container>

              <!-- Edit Mode -->
              <ng-template #editMode>
                <mat-select matSelect formControlName="fromTime" [class.disabled]="viewMode">
                  <mat-option *ngFor="let option of hrs" [value]="option">
                    {{ formatTime24to12(option) }}
                  </mat-option>
                </mat-select>
                <span class="to-text">To</span>
                <mat-select formControlName="toTime" [class.disabled]="viewMode">
                  <mat-option *ngFor="let option of getFilteredToTimeSlots()" [value]="option">
                    {{ formatTime24to12(option) }}
                  </mat-option>
                </mat-select>
              </ng-template>
              </div>
            </div>
          </div>
          <!-- Date and Time -->

          <!-- Duration -->
          <div class="form-group" *ngIf="getMeetingDuration() && this.allDayFlag === false">
            <label for="duration" class="fontbold">Duration:</label>
            <span>
              {{ getMeetingDuration()?.hours }} Hours,
              {{ getMeetingDuration()?.minutes }} Minutes
            </span>
          </div>
          <!-- Duration -->

          <!-- All Day-->
          <!-- <label class="all-day-toggle">
            <input type="checkbox" class="alldaybtn"  (click)="allDay($event)" style="cursor: pointer;" [class.disabled]="viewMode" [attr.disabled]="viewMode ? true : null" formControlName="allDay" />
            <span class="checkmark"></span>
            <span class="label-text">All Day</span>
          </label> -->

            <label class="switch" *ngIf="(viewMode && data?.event?.allday !== false) || !viewMode || editMode">
              <input type="checkbox" (click)="allDay($event)" [disabled]="viewMode" formControlName="allDay" />
              <span class="slider"></span>
            </label>
            
            <span class="label-text" *ngIf="(viewMode && data?.event?.allday !== false) || !viewMode || editMode">
              All Day
            </span>

          <!-- All Day-->

          <!-- Timezone -->
          <div class="weekly-btn timezone-select" *ngIf="!viewMode">
            <img src="assets/addist.svg" class="istme"/>
            <select class="form-select calendorselect" formControlName="timezone">
              <option class="textbox" *ngFor="let i of timezones" [value]="i.value">{{i.label}}</option>
            </select>
          </div>
          <!-- View mode -->
          <div *ngIf="viewMode" class="weekly-btn timezone-select">
            <img src="assets/addist.svg" class="istme"/>
            <span class="selected-timezone">
              {{ getTimezoneLabel(eventForm.get('timezone')?.value) }}
            </span>
          </div>
          <!-- Timezone -->

          <!-- Repeat Option -->
          <!-- <div class="datetime-group">
            <div class="time-block">
              <div class="time-picker-wrapper">
                <mat-select [class.disabled]="viewMode"  class="weekly-btno" formControlName="repeat">
                      <mat-option value="NONE"> None</mat-option>
                      <mat-option value="DAILY">Daily</mat-option>
                      <mat-option value="WEEKLY">Weekly</mat-option>
                      <mat-option value="BIWEEKLY">Bi-Weekly</mat-option>
                      <mat-option value="MONTHLY">Monthly</mat-option>
                      <mat-option value="YEARLY">Yearly</mat-option>
                </mat-select>
              </div>
            </div>
          </div> -->
          
          <div class="datetime-group" *ngIf="data?.event?.recurrence_rule.frequency !== 'NONE' || (data?.event?.recurrence_rule.frequency === 'NONE' && editMode)">
            <div class="time-block">
              <label class="field-label2" style="margin-bottom: 8px !important;"><img src="assets/addrep.svg" class="descme"/> Repetition</label>
              <div class="time-picker-wrapper">
                <!-- View Mode -->
                <div *ngIf="viewMode" class="weekly-btn timezone-select" style="width: 338px;">
                  <span>{{ getRepeatLabel(eventForm.get('repeat')?.value) }}</span>
                </div>
                <!-- Edit Mode -->
                <mat-select *ngIf="!viewMode" [class.disabled]="viewMode" class="weekly-btno" formControlName="repeat" (selectionChange)="onRepetitionChange($event)">
                  <mat-option value="NONE">None</mat-option>
                  <mat-option value="DAILY">Daily</mat-option>
                  <mat-option value="WEEKLY">Weekly</mat-option>
                  <mat-option value="BIWEEKLY">Bi-Weekly</mat-option>
                  <mat-option value="MONTHLY">Monthly</mat-option>
                  <mat-option value="YEARLY">Yearly</mat-option>
                </mat-select>
              </div>
            </div>
          </div>
          <!-- Repeat Option ends -->
          
          <!-- Add Notification -->
          <div class="notifications" *ngFor="let item of notificationItems; let i = index">
            <div class="notification-item2">
              <img src="assets/notifyme.svg" class="notifyme"/>
              <!-- Time Input -->
              <input matInput type="number" [class.disabled]="viewMode" min="0" [(ngModel)]="item.time" [name]="'time' + i" 
              [ngModelOptions]="{standalone: true}" (keydown)="preventNegativeInput($event)" 
              (ngModelChange)="ChangeNotificationValidation(item.time, item.unit, i);enforceNonNegative(i)"/>

              <!-- minutes Unit for viewMode-->
              <div *ngIf="viewMode" class="mtsDiv">
                <span class="noteRep">{{ getTimeLabel(item.unit) }}</span>
                </div>
              <!-- minutes Unit for !viewMode-->
              <div class="mtsDiv">
                <mat-select *ngIf="!viewMode" [(ngModel)]="item.unit" [name]="'unit' + i" [ngModelOptions]="{standalone: true}" (selectionChange)="onNotificationUnitChange($event, i)">
                  <mat-option value="minutes" *ngIf="allDayFlag===false">Minutes</mat-option>
                  <mat-option value="hours" *ngIf="allDayFlag===false">Hours</mat-option>
                  <mat-option value="days">Days</mat-option>
                  <mat-option value="weeks">Weeks</mat-option>
                </mat-select>
              </div>
          
              <!-- Remove Button -->
              <button *ngIf="!viewMode" class="btnRem" mat-icon-button (click)="removeNotification(i)">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <!-- Error message below input -->
            <div *ngIf="item.errorMsg" class="error-msg">
              {{ item.errorMsg }}
            </div>

          </div>
          <a *ngIf="!viewMode" class="add-notification-btn" (click)="addNotification()">+ Add Notification</a>
          <!-- Add Notification ends -->


          <!-- Description -->
          <!-- <label class="field-label2">Description</label>
          <textarea [class.disabled]="viewMode" placeholder="Add Description" maxlength="500" (input)="stripLeadingSpecialChars('description')" aria-label="Add Description" rows="4" formControlName="description"></textarea> -->
          
          <!-- Edit mode -->
          <label class="field-label2" *ngIf="viewMode && descriptionValue"><img src="assets/adddesc.svg" class="descme"/> Description</label>
          <label class="field-label2" *ngIf="!viewMode"> <img src="assets/adddesc.svg" class="descme"/> Description</label>
          <div *ngIf="!viewMode">
            <textarea [class.disabled]="viewMode" placeholder="Additional Message" maxlength="500"
              (input)="stripLeadingSpecialChars('description')" aria-label="Add Description" rows="4"
              formControlName="description"></textarea>
          </div>
          <!-- View mode -->
          <ng-container *ngIf="viewMode && descriptionValue">
            <p class="meetp" *ngIf="eventForm.get('description')?.value; else noLink">
              <span class="meetlink">
                {{ eventForm.get('description')?.value }}
              </span>
            </p>
          
            <!-- Fallback if empty -->
            <ng-template #noLink>
              <input type="text" style="width: 92%;" placeholder="Add Description"
                (input)="stripLeadingSpecialChars('description')" formControlName="description" aria-label="Description" />
            </ng-template>
          </ng-container>
          <!-- Description ends-->

        </div>

        <!-- Right side -->
        <div class="form-right" [ngClass]="{'form-right2': viewMode || editMode}">
        <!-- Guest container -->
          <div class="guest-container">
            <!-- <label class="guest-label">Guests</label> -->
            <label class="field-label"><img src="assets/addguest.svg" class="guestme"/> Guest</label>
            
            <!-- Input dropdown -->
            <div class="dropdown dropoff1" (document:click)="closeDropdown($event, '.dropoff1', 'guest')">
              <!-- <input type="text" placeholder="Add Participants" (focus)="showDropdown = true" (blur)="hideDropdownWithDelay()" [(ngModel)]="searchTerm" (input)="filterGuests()"/> -->
                <input *ngIf="!viewMode" [class.disabled]="viewMode" type="text" [(ngModel)]="searchTerm"
                [ngModelOptions]="{ standalone: true }" (input)="filterGuests()" (paste)="$event.preventDefault()"
                (focus)="showDropdown = true" placeholder="Add Guests"/>

              <ul class="guest-list" *ngIf="showDropdown && filteredGuests.length">
                <li *ngFor="let guest of filteredGuests" (click)="addGuest(guest)">
                  <div class="avatar">
                    <img *ngIf="guest.profile_url; else showInitial" [src]="guest.profile_url" alt="{{ guest.name }}" />
                    <ng-template #showInitial>
                      <div class="initials" [ngStyle]="{ 'background-color': guest.color }">
                        {{ guest.initial }}
                      </div>
                    </ng-template>
                  </div>
                  <div class="guest-info">
                    <div class="guest-name">{{ guest.name }}</div>
                  </div>
                </li>            
              </ul>
            </div>

            <!-- Selected guest list -->
            <div class="selected-guests">
            <!-- Organizer block -->
            <div class="selected-guest" *ngIf="viewMode || editMode">
              <div class="avatar">
                <img *ngIf="data?.event?.owner_profile_url; else noPhotoOrg" [src]="data?.event?.owner_profile_url" alt="{{ data?.event?.owner_name.name }}" />
                <ng-template #noPhotoOrg>
                  <div class="initials" [ngStyle]="{ 'background-color': data?.event?.owner_name?.color }">{{ data?.event?.owner_name?.initial }}</div>
                </ng-template>
              </div>
              <div class="guest-info">
                <div class="guest-name">{{ data?.event?.owner_name?.name }}</div>
                <div class="guest-role">(Organizer)</div>
              </div>
            </div>

              <div class="selected-guest" *ngFor="let guest of selectedGuests">
                <div class="avatar">
                  <img *ngIf="guest?.profile_url; else noPhoto" [src]="guest.profile_url" alt="{{ guest.name }}" />
                  <ng-template #noPhoto>
                    <div class="initials" [ngStyle]="{ 'background-color': guest.color }">{{ guest.initial }}</div>
                  </ng-template>
                </div>
                <div class="guest-info">
                  <div class="guest-name"> {{ guest.name }} 
                    <span class="rsvp-div" *ngIf="guest.rsvp && viewMode">
                    <img *ngIf="guest.rsvp==='yes'" src="assets/images/timeryes.svg" class="tickico"> 
                    <img *ngIf="guest.rsvp==='no'" src="assets/images/timerno.svg" class="tickico">
                    <img *ngIf="guest.rsvp==='maybe'" style="height: 20px;width: 20px;" src="assets/images/timermaybe.svg" class="tickico maybe">
                    </span>
                  </div>
                  <div class="guest-role" *ngIf="guest.role">{{ guest.role }}</div>

                </div>
                <button *ngIf="!viewMode" class="remove-btn" (click)="removeGuest(guest)">x</button>
              </div>
            </div>
          </div>

          <!-- Member dropdown shown only if entity is selected -->
          <div class="guest-container" *ngIf="hasEntityGuest">
            <label class="guest-label"></label>
            <div class="dropdown dropoff2" (document:click)="closeDropdown($event, '.dropoff2', 'member')">
                <input type="text" placeholder="Add Members" [class.disabled]="viewMode"
                [(ngModel)]="searchText" [ngModelOptions]="{ standalone: true }" (paste)="$event.preventDefault()"
                (input)="onEntityMemberInput()" (change)="onEntityMemberInput()" (focus)="showEntityMemberDropdown = true"/>

              <ul class="guest-list" *ngIf="showEntityMemberDropdown && entityMembers.length">
                <li *ngFor="let member of entityMembers" (click)="addEntityMember(member)">
                  <div class="avatar">
                    <img *ngIf="member.profile_url; else memberInitial" [src]="member.profile_url" alt="{{ member.name }}" />
                    <ng-template #memberInitial>
                      <div class="initials" [ngStyle]="{ 'background-color': member.color }">{{ member.initial }}</div>
                    </ng-template>
                  </div>
                  <div class="guest-info">
                    <div class="guest-name">{{ member.name }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
        
            <!-- Selected entity members -->
            <div class="selected-guests" *ngIf="selectedEntityMembers.length">

              <div class="selected-guest" *ngFor="let guest of selectedEntityMembers">
                <div class="avatar">
                  <!-- <img *ngIf="guest.profile_url; else fallback" [src]="guest.profile_url" alt="{{ guest.name }}" /> -->
                  <img *ngIf="guest.profile_url; else fallback" [src]="guest.profile_url" alt="{{ getGuestName(guest) }}" />

                  <ng-template #fallback>
                    <div class="initials" [ngStyle]="{ 'background-color': guest.color }">{{ getGuestInitial(guest) }}</div>
                  </ng-template>
                </div>
                <div class="guest-info">
                  <!-- <div class="guest-name">{{ guest.name }}</div> -->
                  <div class="guest-name">{{ getGuestName(guest) }}
                    <span class="rsvp-div" *ngIf="guest.rsvp && viewMode">
                      <img *ngIf="guest.rsvp==='yes'" src="assets/images/timeryes.svg" class="tickico">
                      <img *ngIf="guest.rsvp==='no'" src="assets/images/timerno.svg" class="tickico">
                      <img *ngIf="guest.rsvp==='maybe'" src="assets/images/timermaybe.svg" class="tickico maybe">
                    </span>
                  </div>
                </div>
                <button *ngIf="!viewMode" class="remove-btn" (click)="removeEntityMember(guest)">x</button>
              </div>

            </div>
          </div>
          <!-- Member dropdown shown only if entity is selected -->
        <!-- Guest container -->

          <!--Location -->
          <!-- <label class="field-label2">Location</label>
          <input type="text" [class.disabled]="viewMode" placeholder="Add Location" (input)="stripLeadingSpecialChars('location')" formControlName="location" aria-label="Add Location" /> -->
        
          <!-- Edit mode -->
          <label class="field-label2" *ngIf="viewMode && locationValue"><img src="assets/addloc.svg" class="locme"/> Location</label>
          <label class="field-label2" *ngIf="!viewMode"><img src="assets/addloc.svg" class="locme"/> Location</label>
          <div *ngIf="!viewMode">
            <input type="text" style="width: 92%;" [class.disabled]="viewMode" placeholder="Add Location"
              (input)="stripLeadingSpecialCharsLink('location')" formControlName="location" aria-label="Location" />
          </div>
          <!-- View mode -->
          <ng-container *ngIf="viewMode && locationValue">
            <p class="meetp" *ngIf="eventForm.get('location')?.value; else noLink">
              <span class="meetlink">
                {{ eventForm.get('location')?.value }}
              </span>
            </p>
          
            <!-- Fallback if empty -->
            <ng-template #noLink>
              <input type="text" style="width: 92%;" placeholder="Add Location" (input)="stripLeadingSpecialCharsLink('location')"
                formControlName="location" aria-label="Location" />
            </ng-template>
          </ng-container>
          <!-- Location ends-->

          
          <!-- Meetings -->
          <!-- Edit mode -->
          <label class="field-label2" *ngIf="viewMode && meetingValue"><img src="assets/addlink.svg" class="clkme"/> Meeting Link</label>
          <label class="field-label2" *ngIf="!viewMode"><img src="assets/addlink.svg" class="clkme"/> Meeting Link</label>
          <div *ngIf="!viewMode">
            <input type="text" style="width: 92%;" [class.disabled]="viewMode" placeholder="Add Meeting Link"
            (input)="stripLeadingSpecialCharsLink('meetingLink')" formControlName="meetingLink" aria-label="Meeting link" />
          </div>
          <!-- View mode -->
          <ng-container *ngIf="viewMode && meetingValue">
            <p class="meetp" *ngIf="eventForm.get('meetingLink')?.value; else noLink">
              <a class="meetlink2" [href]="eventForm.get('meetingLink')?.value" target="_blank">
                {{ eventForm.get('meetingLink')?.value }}
              </a>
            </p>
          
            <!-- Fallback if empty -->
            <ng-template #noLink>
              <input type="text" style="width: 92%;" placeholder="Add Meeting link"
                (input)="stripLeadingSpecialCharsLink('meetingLink')" formControlName="meetingLink" aria-label="Meeting link" />
            </ng-template>
          </ng-container>
          <!-- Meetings ends-->

         <!-- Phone Number -->
          <!-- Edit mode -->
          <label class="field-label2" *ngIf="viewMode && dialinValue"><img src="assets/addcall.svg" class="callme"/> Phone Number</label>
          <label class="field-label2" *ngIf="!viewMode"><img src="assets/addcall.svg" class="callme"/> Phone Number</label>
          <div *ngIf="!viewMode">
            <input type="text" style="width: 92%;" [class.disabled]="viewMode" placeholder="Add Phone Number" maxlength="10"
            (input)="stripLeadingSpecialCharsLink('dialin')" formControlName="dialin" aria-label="Phone Number" />
          </div>
          <!-- View mode -->
          <ng-container *ngIf="viewMode && dialinValue">
            <p class="meetp" *ngIf="eventForm.get('dialin')?.value; else noLink">
              <span class="meetlink">
                {{ eventForm.get('dialin')?.value }}
              </span>
            </p>
          
            <!-- Fallback if empty -->
            <ng-template #noLink>
              <input type="text" style="width: 92%;" placeholder="Add Phone Number"
                (input)="stripLeadingSpecialCharsLink('dialin')" formControlName="dialin" aria-label="Phone Number" />
            </ng-template>
          </ng-container>
          <!-- Phone Number ends-->


          <!-- Document attach-->
          <div class="row containerbox formcontainer" *ngIf="data?.event?.attachments?.length > 0">
            <label class="field-label2"> <i class="bi bi-paperclip" style="font-size: 18px;"></i>Documents</label>
          
            <div class="col-sm-6" *ngFor="let doc of data.event.attachments">
              <div class="documentbox">
                <p class="meetingitem itemFlex dname">  
                  <i class="bi bi-file-earmark-text"></i> 
                  {{doc.name}} &nbsp; 
                  <i class="bi bi-eye viewdoc" (click)="viewDocument(doc)"></i>
                </p>
              </div>
            </div>
          </div>
          <!-- Document attach-->

          <!-- <button type="button" class="default-color-btn">
            <span class="color-indicator"></span> Default Color
          </button> -->

          <div class="form-actions" *ngIf="!viewMode" [ngClass]="{'faBtn': viewMode || editMode}">
            <button type="submit" class="save-btn" 
            [disabled]="eventForm.get('title')?.invalid || eventForm.get('title')?.value?.trim() === ''"
            (click)="onSubmit()">Save</button>
            <button type="button" class="cancel-btn" (click)="onCancel()">Cancel</button>
          </div>
        </div>
      </form>
    </div>
  <!-- Event Tab Content ends here-->

  <!-- Reminder Tab Content -->
    <div class="reminder-tab" *ngIf="selectedTab === 'Reminder'">
      <form [formGroup]="eventForm" class="modal-form" [ngClass]="{'scrollTab': viewMode || editMode}" aria-label="Create Event Form">
        <!-- Left side -->
        <div class="form-left">
          <input class="input-title" [class.disabled]="viewMode" maxlength="255" (input)="stripLeadingSpecialChars('title')" type="text" formControlName="title" placeholder="Add Reminder Title" aria-label="Add Event Title" />
          <div class="error-message" *ngIf="hasError('title')">
            Reminder title is required
          </div>

          <!-- Date and Time -->
          <div class="datetime-group">
            <div class="date-block">
              <div class="date-picker-wrapper">
                <label class="field-label">Date</label>
                <input matInput [min]="minDate" [class.disabled]="viewMode" style="cursor: pointer;" (click)="openStartPicker()"
                  [matDatepicker]="startPicker" formControlName="startDate" (focus)="startPicker.open()"
                  (click)="startPicker.open()" readonly />
                <!-- <mat-datepicker-toggle *ngIf="!viewMode" matSuffix [for]="startPicker"></mat-datepicker-toggle> -->
                <img *ngIf="!viewMode" src="assets/datepicko.svg" alt="Pick date" style="width: 25px; cursor: pointer; margin-left: 8px;" (click)="startPicker.open()" />
                <mat-datepicker #startPicker [disabled]="viewMode"></mat-datepicker>
              </div>
            </div>
          </div>

          <!-- Time -->
          <div class="datetime-group" *ngIf="!isAllDay">
            <div class="time-block">
              <div class="time-picker-wrapper">
                <!-- <label class="field-label">Time<span class="required">*</span></label> -->
                <img src="assets/addclock.svg" class="clkme" />

                <!-- View Mode -->
                <ng-container *ngIf="viewMode; else editMode">
                  <span class="fromtoRep">{{ formatTime24to12(eventForm.get('fromTime')?.value) }}</span>
                  <span class="to-text">To</span>
                  <span class="fromtoRep">{{ formatTime24to12(eventForm.get('toTime')?.value) }}</span>
                </ng-container>

              <!-- Edit Mode -->
              <ng-template #editMode>
                <mat-select matSelect formControlName="fromTime" [class.disabled]="viewMode">
                  <mat-option *ngFor="let option of hrs" [value]="option">
                    {{ formatTime24to12(option) }}
                  </mat-option>
                </mat-select>
                <span class="to-text">To</span>
                <mat-select formControlName="toTime" [class.disabled]="viewMode">
                  <mat-option *ngFor="let option of getFilteredToTimeSlots()" [value]="option">
                    {{ formatTime24to12(option) }}
                  </mat-option>
                </mat-select>
              </ng-template>
              </div>
            </div>
          </div>
          <!-- Time -->

          <!-- Duration -->
          <div class="form-group" *ngIf="getMeetingDuration() && this.allDayFlag === false">
            <label for="duration" class="fontbold">Duration:</label>
            <span>
              {{ getMeetingDuration()?.hours }} Hours,
              {{ getMeetingDuration()?.minutes }} Minutes
            </span>
          </div>
          <!-- Duration -->

          <!-- All Day-->
            <label class="switch" *ngIf="(viewMode && data?.event?.allday !== false) || !viewMode || editMode">
              <input type="checkbox" (click)="allDay($event)" [disabled]="viewMode" formControlName="allDay" />
              <span class="slider"></span>
            </label>
            
            <span class="label-text" *ngIf="(viewMode && data?.event?.allday !== false) || !viewMode || editMode">
              All Day
            </span>
          <!-- All Day-->

          <!-- Timezone -->
          <div class="weekly-btn timezone-select" *ngIf="!viewMode">
            <img src="assets/addist.svg" class="istme"/>
            <select class="form-select calendorselect" formControlName="timezone">
              <option class="textbox" *ngFor="let i of timezones" [value]="i.value">{{i.label}}</option>
            </select>
          </div>
          <!-- View mode -->
          <div *ngIf="viewMode" class="weekly-btn timezone-select">
           <img src="assets/addist.svg" class="istme"/>
            <span class="selected-timezone">
              {{ getTimezoneLabel(eventForm.get('timezone')?.value) }}
            </span>
          </div>
          <!-- Timezone -->

          <!-- Repeat Option -->          
          <div class="datetime-group">
            <div class="time-block">
              <div class="time-picker-wrapper">
                <!-- View Mode -->
                <div *ngIf="viewMode" class="weekly-btn timezone-select" style="width: 338px;">
                  <span>{{ getRepeatLabel(eventForm.get('repeat')?.value) }}</span>
                </div>
                <!-- Edit Mode -->
                <mat-select *ngIf="!viewMode" [class.disabled]="viewMode" class="weekly-btno" formControlName="repeat" (selectionChange)="onRepetitionChange($event)">
                  <mat-option value="NONE">None</mat-option>
                  <mat-option value="DAILY">Daily</mat-option>
                  <mat-option value="WEEKLY">Weekly</mat-option>
                  <mat-option value="BIWEEKLY">Bi-Weekly</mat-option>
                  <mat-option value="MONTHLY">Monthly</mat-option>
                  <mat-option value="YEARLY">Yearly</mat-option>
                </mat-select>
              </div>
            </div>
          </div>
          
          <!-- Notification -->
          <div class="notifications" *ngFor="let item of notificationItems; let i = index">
            <div class="notification-item2">
              <img src="assets/notifyme.svg" class="notifyme"/>
              <!-- Time Input -->
              <input matInput type="number" [class.disabled]="viewMode" min="0" [(ngModel)]="item.time" [name]="'time' + i" 
              [ngModelOptions]="{standalone: true}" (keydown)="preventNegativeInput($event)" 
              (ngModelChange)="ChangeNotificationValidation(item.time, item.unit, i);enforceNonNegative(i)"/>

              <!-- minutes Unit for viewMode-->
              <div *ngIf="viewMode" class="mtsDiv">
                <span class="noteRep">{{ getTimeLabel(item.unit) }}</span>
                </div>
              <!-- minutes Unit for !viewMode-->
              <div class="mtsDiv">
                <mat-select *ngIf="!viewMode" [(ngModel)]="item.unit" [name]="'unit' + i" [ngModelOptions]="{standalone: true}" (selectionChange)="onNotificationUnitChange($event, i)">
                  <mat-option value="minutes" *ngIf="allDayFlag===false">Minutes</mat-option>
                  <mat-option value="hours" *ngIf="allDayFlag===false">Hours</mat-option>
                  <mat-option value="days">Days</mat-option>
                  <mat-option value="weeks">Weeks</mat-option>
                </mat-select>
              </div>
          
              <!-- Remove Button -->
              <button *ngIf="!viewMode" class="btnRem" mat-icon-button (click)="removeNotification(i)">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <!-- Error message below input -->
            <div *ngIf="item.errorMsg" class="error-msg">
              {{ item.errorMsg }}
            </div>

          </div>
          <a *ngIf="!viewMode" class="add-notification-btn" (click)="addNotification()">+ Add Notification</a>
          <!-- Add Notification ends -->

          <!-- Description -->
          <!-- <label class="field-label2">Description</label>
          <textarea [class.disabled]="viewMode" placeholder="Additional Message" maxlength="500" (input)="stripLeadingSpecialChars('description')" aria-label="Add Description" rows="4" formControlName="description"></textarea> -->
          
          <!-- Edit mode -->
          <label class="field-label2" *ngIf="viewMode && descriptionValue"><img src="assets/adddesc.svg" class="descme"/> Description</label>
          <label class="field-label2" *ngIf="!viewMode"><img src="assets/adddesc.svg" class="descme"/> Description</label>
          <div *ngIf="!viewMode">
            <textarea [class.disabled]="viewMode" placeholder="Additional Message" maxlength="500"
              (input)="stripLeadingSpecialChars('description')" aria-label="Add Description" rows="4"
              formControlName="description"></textarea>
          </div>
          <!-- View mode -->
          <ng-container *ngIf="viewMode && descriptionValue">
            <p class="meetp" *ngIf="eventForm.get('description')?.value; else noLink">
              <span class="meetlink">
                {{ eventForm.get('description')?.value }}
              </span>
            </p>
          
            <!-- Fallback if empty -->
            <ng-template #noLink>
              <input type="text" style="width: 92%;" placeholder="Add Description"
                (input)="stripLeadingSpecialChars('description')" formControlName="description" aria-label="Description" />
            </ng-template>
          </ng-container>
          <!-- Description ends-->

        </div>

        <!-- Right side -->
        <div class="form-right" [ngClass]="{'form-right2': viewMode || editMode}">

          <!--Location -->
          <!-- Edit mode -->
          <label class="field-label2" *ngIf="viewMode && locationValue"><img src="assets/addloc.svg" class="locme"/> Location</label>
          <label class="field-label2" *ngIf="!viewMode"><img src="assets/addloc.svg" class="locme"/> Location</label>
          <div *ngIf="!viewMode">
            <input type="text" style="width: 92%;" [class.disabled]="viewMode" placeholder="Add Location"
              (input)="stripLeadingSpecialCharsLink('location')" formControlName="location" aria-label="Location" />
          </div>
          <!-- View mode -->
          <ng-container *ngIf="viewMode && locationValue">
            <p class="meetp" *ngIf="eventForm.get('location')?.value; else noLink">
              <span class="meetlink">
                {{ eventForm.get('location')?.value }}
              </span>
            </p>
          
            <!-- Fallback if empty -->
            <ng-template #noLink>
              <input type="text" style="width: 92%;" placeholder="Add Location" (input)="stripLeadingSpecialCharsLink('location')"
                formControlName="location" aria-label="Location" />
            </ng-template>
          </ng-container>
          <!-- Location ends-->
        
          <!-- Meetings -->         
          <label class="field-label2" *ngIf="viewMode && meetingValue"><img src="assets/addlink.svg" class="clkme"/> Meeting Link</label>
          <label class="field-label2" *ngIf="!viewMode"><img src="assets/addlink.svg" class="clkme"/> Meeting Link</label>
          <!-- Edit mode -->
          <div *ngIf="!viewMode">
            <input type="text" style="width: 92%;" placeholder="Add Meeting Link"
            (input)="stripLeadingSpecialCharsLink('meetingLink')" formControlName="meetingLink" aria-label="Meeting link" />
          </div>
          <!-- View mode -->
          <ng-container *ngIf="viewMode && meetingValue">
            <p class="meetp" *ngIf="eventForm.get('meetingLink')?.value; else noLink">
              <a class="meetlink2" [href]="eventForm.get('meetingLink')?.value" target="_blank">
                {{ eventForm.get('meetingLink')?.value }}
              </a>
            </p>
          
            <!-- Fallback if empty -->
            <ng-template #noLink>
              <input type="text" style="width: 92%;" placeholder="Add Meeting Link"
                (input)="stripLeadingSpecialCharsLink('meetingLink')" formControlName="meetingLink" aria-label="Meeting link" />
            </ng-template>
          </ng-container>
          <!-- Meetings ends-->
   
          <!-- Phone Number -->
          <label class="field-label2" *ngIf="viewMode && dialinValue"><img src="assets/addcall.svg" class="callme"/> Phone Number</label>
          <label class="field-label2" *ngIf="!viewMode"><img src="assets/addcall.svg" class="callme"/> Phone Number</label>
          <!-- Edit mode -->
          <div *ngIf="!viewMode">
            <input type="text" style="width: 92%;" placeholder="Add Phone Number" maxlength="10"
            (input)="stripLeadingSpecialCharsLink('dialin')" formControlName="dialin" aria-label="Phone Number" />
          </div>
          <!-- View mode -->
          <ng-container *ngIf="viewMode && dialinValue">
            <p class="meetp" *ngIf="eventForm.get('dialin')?.value; else noLink">
              <span class="meetlink">
                {{ eventForm.get('dialin')?.value }}
              </span>
            </p>
          
            <!-- Fallback if empty -->
            <ng-template #noLink>
              <input type="text" style="width: 92%;" placeholder="Phone Number"
                (input)="stripLeadingSpecialCharsLink('dialin')" formControlName="dialin" aria-label="Phone Number" />
            </ng-template>
          </ng-container>
          <!-- Phone Number ends-->

          <!-- <button type="button" class="default-color-btn">
            <span class="color-indicator"></span> Default Color
          </button> -->

          <div class="form-actions" *ngIf="!viewMode" [ngClass]="{'faBtn': viewMode || editMode}">
            <button type="submit" class="save-btn" 
            [disabled]="eventForm.get('title')?.invalid || eventForm.get('title')?.value?.trim() === ''"
            (click)="onSubmit()">Save</button>
            <button type="button" class="cancel-btn" (click)="onCancel()">Cancel</button>
          </div>
        </div>
      </form>
      
    </div>
  <!-- Reminder Tab Content ends here-->

</div>


<!-- Document Preview Modal -->
    <div *ngIf="isPreviewOpen" class="preview-modal">
      <div class="preview-content">
        <div class="preview-header">
          <h2>{{ previewDocument?.name }}</h2>
          <button mat-icon-button (click)="closePreview()">
            <i class="material-icons">close</i>
          </button>
        </div>

        <div class="iframe-wrapper">
          <div *ngIf="isPreviewLoading" class="iframe-spinner-overlay">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Loading document preview...</p>
          </div>

          <ng-container *ngIf="!isPreviewLoading && previewDocument" [ngSwitch]="previewDocument.mimeType">
            <iframe *ngSwitchCase="'application/pdf'" [src]="previewDocument.previewUrl"></iframe>

            <img *ngSwitchCase="'image/jpeg'" [src]="previewDocument.previewUrl" [alt]="previewDocument.name">
            <img *ngSwitchCase="'image/png'" [src]="previewDocument.previewUrl" [alt]="previewDocument.name">

            <div *ngSwitchDefault class="no-preview">
              <img class="docmat" src="assets/images/docs.png" alt="document icon">
              <p>Preview not available for this file type</p>
            </div>
          </ng-container>

        </div>
      </div>
    </div>
<!-- Document Preview Modal -->
